import type { AdController, ShowPromiseResult } from '@/types/adsgram'
import webapp from '@/services/webapp'
import { env } from '@/env'

const adForSpin = window.Adsgram?.init({ blockId: '2482' })
const adForDoubleOfflineProfit = window.Adsgram?.init({ blockId: '4788' })
const adForInterstitial = window.Adsgram?.init({ blockId: 'int-5560' })
const adForDoublePrize = window.Adsgram?.init({ blockId: '3769' })

class NullAdController implements AdController {
  public async show(): Promise<ShowPromiseResult> {
    await webapp.showAlert('You are watching an ad')

    return {
      done: true,
      error: false,
      state: 'load',
      description: 'Adsgram missing',
    }
  }

  public addEventListener(): void {
  }

  public removeEventListener(): void {
  }

  public destroy(): void {
  }
}

export default (env.app.isProd ? adForSpin : new NullAdController()) as AdController

export const adControllers = {
  adForSpin: (env.app.isProd ? adForSpin : new NullAdController()) as AdController,
  adForDoubleOfflineProfit: (env.app.isProd ? adForDoubleOfflineProfit : new NullAdController()) as AdController,
  adForInterstitial: (env.app.isProd ? adForInterstitial : new NullAdController()) as AdController,
  adForDoublePrize: (env.app.isProd ? adForDoublePrize : new NullAdController()) as AdController,
}
